import { Avatar, Card, Grid, Stack } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { getFileURL } from "common/redux.actions";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
function HeaderCard({ dataInfo, dataIdentificationInfo }) {

    const RXDispatch = useDispatch();
    const theme = useTheme();
    const [profileUrl, setProfileUrl] = useState(null);

    useEffect(() => {
        const profileUrl = dataIdentificationInfo.find((info) => info.key === 'photograph')?.link
        if (profileUrl) {
            RXDispatch(getFileURL({
                handleSubmit, payload: { url: profileUrl }
            }));
        }
    }, []);

    const handleSubmit = (resp) => {
        if (resp.type === "success") {
            setProfileUrl(resp.url);
        }
    };
    return (
        <Card sx={(t) => ({ mb: 4, bgcolor: 'background.paper', border: `1px solid ${t.palette.divider}` })}>
            <Grid container spacing={1} sx={{ justifyContent: 'space-between', p: 4 }}>
                <Grid item xs={12} sm={4}>
                    <Avatar 
                        src={profileUrl} 
                        sx={{ 
                            bgcolor: theme.palette.primary.main, 
                            width: 124, 
                            height: 124, 
                            fontSize: 72, 
                            '@media (max-width: 599px)': { margin: 'auto' },
                            '@media (min-width: 600px)': { margin: '0' }
                        }}
                        alt={dataInfo ? dataInfo.find((info) => info.key === 'firstname')?.value?.at(0) : ""}
                    >
                        {dataInfo ? dataInfo.find((info) => info.key === 'firstname')?.value?.at(0) : ""}
                    </Avatar>
                </Grid>
                <Grid item xs={6} sm={4}>
                    <Typography variant="h6" sx={{ fontWeight: "Bold" }}>{dataInfo.find((info) => info.key === 'initial')?.value} {dataInfo.find((info) => info.key === 'firstname')?.value} {dataInfo.find((info) => info.key === 'middlename')?.value} {dataInfo.find((info) => info.key === 'lastname')?.value}</Typography>
                    <Typography variant="subtitle1" sx={{ fontWeight: "Bold" }}>{dataInfo.find((info) => info.key === 'designation')?.value}</Typography>
                    <Typography variant="subtitle1" sx={{ fontWeight: "Bold" }}>{dataInfo.find((info) => info.key === 'employeeId')?.value}</Typography>
                </Grid>
                <Grid item xs={6} sm={4}>
                    <Stack direction="column" spacing={1}>
                        <Typography variant="subtitle1" sx={{ fontWeight: "Bold" }}>Joining Date: {dayjs(dataInfo.find((info) => info.key === 'joiningDate')?.value).format("YYYY-MM-DD")}</Typography>
                        <Typography variant="subtitle1" sx={{ fontWeight: "Bold" }}>Department: {dataInfo.find((info) => info.key === 'department')?.value}</Typography>
                        <Typography variant="subtitle1" sx={{ fontWeight: "Bold" }}>Designation: {dataInfo.find((info) => info.key === 'designation')?.value}</Typography>
                    </Stack>
                </Grid>
            </Grid>
        </Card>
    )
}

export default HeaderCard
